/* eslint-disable no-console */
/* eslint-disable no-secrets/no-secrets */
/* eslint-disable padding-line-between-statements */

import { MetadataContent } from '@jutro/legacy/uiconfig';
import { useEffect, useCallback, useContext, useState } from 'react';
import _ from 'lodash';
import { TranslatorContext } from '@jutro/locale';
import { useAciUtil } from 'ent-capability-hooks';
import messages from './PaymentMethodComponent.messages';
import metadata from './PaymentMethodComponent.metadata.json5';
import styles from './PaymentMethodComponent.module.scss';

function PaymentMethodComponent(props) {
    const {
        payFrom, 
          offer, 
          bindData, 
          authHeader,  
          identifier, // policy number being sent in for Invoices
          selectedInvList, // selected Invoices List being sent in from Invoices
          lobCode,  
          streamPublicId, // needed for auto pay - add payment method 
          onSelectedInstrumentChange ,  // func passed from parent - then passed on to metadata for processing.
          paymentInstrument, // state lifted to parent to be shared with sibling
          paymentInstruments, // state lifted to parent to be shared with sibling
          selectedBaseAmount, 
          accountNumberIdentifier,
          selectedPaymentInstrument,
          isAutoDraft,
          useProfile,
          enableEdit,
          paymentPlanIn,
          history,
        } = props;
   
    const { addPaymentInstrumentsToAccount } = useAciUtil();
    const [loading, setLoading] = useState(false);
    const translator = useContext(TranslatorContext);  
    const [baseAmount, setBaseAmount] = useState({});
    const [paymentPlan, setPaymentPlan] = useState('');
 
    useEffect(() => {
        setLoading(true);
        // payfrom can be from offers, invoices, autopay screens
       if (payFrom === "offers"){
            setBaseAmount( _.get(bindData, 'customerPaymentDetails_TWIA.amount'));
            setPaymentPlan(_.get(bindData, 'selectedPaymentPlan'));
        } else if (payFrom === "invoices") {
           setBaseAmount(selectedBaseAmount);
           setPaymentPlan(paymentPlanIn);
        } else if (payFrom === "autoPay"){
            setPaymentPlan(paymentPlanIn);
        }
        setLoading(false);
         
    }, [bindData, selectedBaseAmount, payFrom, isAutoDraft, paymentPlanIn, authHeader, accountNumberIdentifier, selectedPaymentInstrument, streamPublicId]);

    const onAddPaymentMethod = useCallback(() => {
        setLoading(true);

        let method;
        let lobCodeByFunc;
        let fullNameByFunc;
        let emailAddressByFunc;
        let accountNumberByFunc;
        let stateByFunc;
        
        if (payFrom === "offers"){
             const isRenewal = _.get(offer, 'jobType_TWIA') === 'Renewal';
             method = isRenewal ? 'RENEWAL_OFFER_PAYMENT' : 'OFFER_PAYMENT';
             lobCodeByFunc =  _.get(offer, 'productCodeIdentifier_TWIA'); 
             fullNameByFunc = bindData.accountHolderName_TWIA;
             emailAddressByFunc = bindData.contactEmail;
             accountNumberByFunc =  accountNumberIdentifier;                 
             const amount= _.get(bindData, 'customerPaymentDetails_TWIA.amount');
             const plan = _.get(bindData, 'selectedPaymentPlan');
             stateByFunc = { baseAmount: amount, paymentPlan: plan, autoPay: isAutoDraft };
        } else if (payFrom === "invoices") {
            // we are dealing with invoices screen
             method = 'INVOICE_PAYMENT';
             lobCodeByFunc = lobCode;
             fullNameByFunc = '';
             emailAddressByFunc = '';
             accountNumberByFunc = accountNumberIdentifier;    
             const uniqueInvoicesList = selectedInvList?.length > 1 ? [...new Set(selectedInvList)]: selectedInvList;      
             stateByFunc = { baseAmount, policyNumber: identifier,  accountNumber: accountNumberIdentifier, selectedInvoicesList: uniqueInvoicesList, paymentPlan, autoPay: isAutoDraft  };
        } else if (payFrom === "autoPay") {
            method = "ENABLE_AUTOPAY";
            lobCodeByFunc = lobCode;
            fullNameByFunc = '';
            emailAddressByFunc = '';
            accountNumberByFunc = accountNumberIdentifier;
            stateByFunc = {
                action : 'new',
                accountNumber: accountNumberIdentifier,
                autoPay: isAutoDraft
            };
        }

       try {
        const currState = window.encodeURIComponent(window.btoa(JSON.stringify(stateByFunc)));

        /**
         * UseProfile variable is preset by business rules for Invoices and AutoPay screens.
         * Hence this varible is passed into the addPaymentInstrumentsToAccount function.
         * isAutoDraft variable is used to determine if AutoPay is enable or not for setting up Edit AutoPay
         * vs. Setup AutoPay screens and hence needs to be kept separate.
         * For Offers - useProfile is determined by the isAutoDraft variable.
         */
        addPaymentInstrumentsToAccount({
            payFrom,
            selectedAccountNumber: accountNumberByFunc,
            identifier, 
            method, 
            lob:lobCodeByFunc,
            fullName: fullNameByFunc,
            emailAddress: emailAddressByFunc,
            useProfile: (payFrom === 'invoices' || payFrom === 'autoPay')?useProfile: isAutoDraft,
            streamPublicId,
            currState,  
            authHeader,
            history,
            onComplete: () => { setLoading(false); }
        });
        }
        catch (e){
            console.log(`Error : ${e}`);
            setLoading(false);
        }
        finally{
            setLoading(false);
        }
       
    },[payFrom, offer, bindData, accountNumberIdentifier, isAutoDraft, lobCode, baseAmount, identifier, selectedInvList, paymentPlan, addPaymentInstrumentsToAccount, useProfile, streamPublicId, authHeader, history]);

    const getPaymentMethodTitle = () =>{
        let retStr;
        if (payFrom === "autoPay" && !isAutoDraft){
            retStr = messages.selectAutomaticPaymentMethod;
        } 
        if (payFrom === "autoPay" && isAutoDraft){
            retStr= messages.editAutomaticPaymentMethod;
        } 
        if (payFrom === "offers" || payFrom === "makeAPayment"){
            retStr= messages.selectPaymentMethod
        }
        return retStr
    }

    const getAvailableValues = () => paymentInstruments?.map((pi) => {
            // ACI nickname field is optional
            const description = pi.description ? pi.description : ''                   
            return {
                code: `${pi.publicID}`,
                name: `${description} ${pi.detail}`
            }
        })

    const overrideProps = {
        paymentMethodsLoader: {
            loadingMessage: translator(messages.loading),
            visible: loading
        },
        paymentMethodTitle: {
            content: getPaymentMethodTitle()
        },
        paymentMethods: {
            availableValues: getAvailableValues(),
            value: !_.isEmpty(paymentInstrument)?paymentInstrument:undefined,
            visible: !loading,
            readOnly: enableEdit
        },
        addPaymentMethodButton: {
            visible: !loading,
            disabled: enableEdit
        }
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            onAddPaymentMethod,
            onSelectedInstrumentChange
        }
    };

    return (
        // eslint-disable-next-line react/react-in-jsx-scope
        <MetadataContent
            uiProps={metadata.componentContent}
            overrideProps={overrideProps}
            {...resolvers}
        />
    );
}

export default PaymentMethodComponent;
